module.exports = __webpack_public_path__ + "static/img/banana.b742de2a.webp";